// module
import * as R from 'ramda'
import { fromEvent } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { WAPP_DEV_ENV_SRC_URL } from 'weblite-web-wapprunner'
import hostConf from '$config/frontend'
// setup
import { wappSub } from '$func/subscription'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'

// TODO: Find a safer way
const validateAction = ({ meta }) => meta?.wappId

fromEvent(window, 'message')
  .pipe(
    filter(
      action =>
        action?.origin === hostConf.WAPPS_HOST ||
        action?.origin === WAPP_DEV_ENV_SRC_URL,
    ),
    map(({ data }) => {
      try {
        return JSON.parse(data)
      } catch (e) {
        return {}
      }
    }),
    filter(validateAction),
  )
  .subscribe(action => {
    wappSub.publish(action)
    wappSubscription.publish(action)
  })
